import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VToolbar,{staticClass:"sunset-admin-app-bar",attrs:{"dark":"","dense":"","fixed":""}},[_c(VToolbarTitle,[_vm._v("LionDesk Sunset Admin")]),_c(VSpacer),_c(VBtn,{attrs:{"text":""},on:{"click":_vm.handleLogout}},[_vm._v("Sign out")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }